import { useState, useEffect } from 'react';
import axios from 'axios';

export const usePricing = (configuration) => {
  const [pricing, setPricing] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (Object.keys(configuration).length > 0) {
      calculatePricing();
    }
  }, [configuration]);

  const calculatePricing = async () => {
    try {
      setLoading(true);
      const response = await axios.post('/api/pricing/calculate', {
        configuration
      });

      if (response.data.success) {
        setPricing(response.data.pricing);
        setError(null);
      }
    } catch (err) {
      // Don't set error for incomplete configurations
      if (err.response?.data?.validationErrors) {
        // Configuration is incomplete but not an error
        setPricing(null);
      } else {
        setError('Failed to calculate pricing');
        console.error('Pricing error:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  };

  return {
    pricing,
    loading,
    error,
    formatPrice,
    recalculate: calculatePricing
  };
};
